// extracted by mini-css-extract-plugin
export default {"wrap":"Main_wrap__vSoGb","hide":"Main_hide__3QBWQ"};